import React, { useEffect,useState} from 'react';
import '../styles/Statement.css';
import CoverPoster from '../assets/Cover_poster.gif';

const Statement = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Array with texts to type in typewriter
        const dataText = [
            "Hi! I am Jiaqi. Welcome to my website💡 ;)",
            "I believe that technology🚀 should empower designers and communities to create better built environments...",
            "Let's build 🛠️ together!"
        ];

        // Type one text in the typewriter
        function typeWriter(text, i, fnCallback) {
            if (i < text.length) {
                document.getElementById("typewriter-text").innerHTML = text.substring(0, i + 1) + '<span aria-hidden="true"></span>';
                setTimeout(() => {
                    typeWriter(text, i + 1, fnCallback);
                }, 100);
            } else if (typeof fnCallback === 'function') {
                setTimeout(fnCallback, 700);
            }
        }

        // Start a typewriter animation for a text in the dataText array
        function startTextAnimation(i) {
            if (i < dataText.length) {
                typeWriter(dataText[i], 0, () => {
                    startTextAnimation(i + 1);
                });
            } else {
                setTimeout(() => {
                    startTextAnimation(0);
                }, 2200); // Repeat after delay
            }
        }
        setIsVisible(true);
        // Trigger the slide-in animation after a slight delay
        const timer = setTimeout(() => {
            
            startTextAnimation(0);
        }, 2100); // Adjust delay as needed

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={`statement ${isVisible ? 'slide-in' : ''}`}>
            <h1 id="typewriter-text"></h1>
            <img 
                src={CoverPoster} 
                alt="Cover Poster"
                style={{ width: '100%', height: 'auto' }}
            />
        </div>
    );
};

export default Statement;